class StepCarousel extends window.HTMLElement {
    constructor() {
        super()
        this.selectors = {
            loop: "data-loop",
            autoplay: "data-autoplay",
            autoplayInterval: "data-autoplay-interval",
            carouselContainer: ".carousel-container",
            progressBar: "[data-progress-bar]",
            isHorizontal: "data-horizontal"
        }
        this.autoplayPlugin = null
        this.embla = null
        this.isHorizontal = false
    }

    connectedCallback() {
        // Get basic configuration
        const loop = this.hasAttribute(this.selectors.loop)
        const autoplay = this.hasAttribute(this.selectors.autoplay)
        const autoplayInterval = parseInt(this.getAttribute(this.selectors.autoplayInterval)) || 5000
        const carouselContainer = this.querySelector(this.selectors.carouselContainer)
        this.isHorizontal = this.hasAttribute(this.selectors.isHorizontal)

        // Set up autoplay plugin
        const plugins = []
        if (autoplay) {
            this.autoplayPlugin = EmblaCarouselAutoplay({
                delay: autoplayInterval,
                stopOnInteraction: false,
            })
            plugins.push(this.autoplayPlugin)
        }

        // Initialize carousel
        this.embla = EmblaCarousel(
            carouselContainer,
            {
                loop: loop,
                watchDrag: true,
                duration: 20,
            },
            plugins
        )

        // Set up progress bar for initial slide
        this.resetProgressBar()
        
        // Start progress animation for first slide
        if (autoplay) {
            this.animateProgress(autoplayInterval)
        }
        
        // Handle slide changes
        this.embla.on("select", () => {
            this.resetProgressBar()
            this.animateProgress(autoplayInterval)
        })
    }

    disconnectedCallback() {
        if (this.embla) {
            this.embla.destroy()
            this.embla = null
        }
    }

    animateProgress(duration = 5000) {
        const progressBar = this.querySelector(this.selectors.progressBar)
        if (!progressBar) return
        
        // Set transition and animate to 100%
        requestAnimationFrame(() => {
            if (this.isHorizontal) {
                progressBar.style.transition = `width ${duration}ms linear`
                progressBar.style.width = "100%"
            } else {
                progressBar.style.transition = `height ${duration}ms linear`
                progressBar.style.height = "100%"
            }
        })
    }

    resetProgressBar() {
        const progressBar = this.querySelector(this.selectors.progressBar)
        if (!progressBar) return
        
        // Set to 0% without transition
        progressBar.style.transition = "none"
        
        if (this.isHorizontal) {
            progressBar.style.width = "0%"
        } else {
            progressBar.style.height = "0%"
        }
        
        // Force reflow
        progressBar.offsetHeight
    }
}

window.customElements.define("step-carousel", StepCarousel)